import { API_ENDPOINT } from "@ApiConstant";
import axios from "axios";
// import {ToastMsg} from "src/helper/ToastMsg";


export const upiPay = (data, token, paymentGatewayType) => {
  let exceptIcici = `${API_ENDPOINT}/api/transaction/repayment_initiate/`;

  let url =
    paymentGatewayType === "icici"
      ? `${API_ENDPOINT}/api/transaction/repayment_initiate_icici/`
      : exceptIcici;

  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          //  console.log(err, "rejecttttt"); 
          return reject(err)
        });
    });
};

export const getStatus = (data, token) => {
  let url = `${API_ENDPOINT}/api/transaction/repayment_status/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          setLoader(false);
          if (err.response?.status === 401) {
           window.location.href = "/";
          localStorage.removeItem("gpay_token");
          }
          let error = err?.response?.data?.error;
          ToastMsg(error, "error");
          // console.log(err);
        });
    });
};
